import './kbd.scss';

import type { FC, ReactNode } from 'react';

/** True on Apple platforms, where the palette shortcut is ⌘K rather than Ctrl K. */
export const isApplePlatform = (): boolean => {
	if (typeof navigator === 'undefined') return false;
	const platform =
		(navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ?? navigator.platform ?? '';
	return /mac|iphone|ipad|ipod/i.test(platform);
};

/** The modifier glyph for the current platform: `⌘` or `Ctrl`. */
export const modKeyLabel = (): string => (isApplePlatform() ? '⌘' : 'Ctrl');

/** A keyboard key, as printed on the keycap. Decorative to assistive tech when `aria-hidden` is passed. */
const Kbd: FC<{ 'children': ReactNode; 'aria-hidden'?: boolean }> = ({ children, ...rest }) => (
	<kbd
		className='ielect-kbd'
		{...rest}
	>
		{children}
	</kbd>
);

export default Kbd;
